<p-dialog
    [header]="'Generate default pages with AI'"
    [visible]="visible()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '64rem' }"
    [breakpoints]="{ '1280px': '95vw' }"
    [modal]="true"
    [draggable]="false"
    appendTo="body"
>
    <!-- ── Config ─────────────────────────────────────────────────────────── -->
    @if (phase() === 'config') {
    <div class="flex flex-col gap-4">
        <p class="text-sm text-muted-color">
            Generates {{ 3 }} portrait promo pages (shown on the game detail
            page) in a reference site template's style. Scenes and marketing copy
            are written automatically. Pick one candidate per page afterwards.
        </p>

        @if (!lockedRef()) {
        <div class="flex flex-col gap-2">
            <label class="font-medium">Reference site template</label>
            @if (preparing()) {
            <div class="flex items-center gap-2 text-muted-color text-sm py-2">
                <i class="pi pi-spin pi-spinner"></i>
                <span>Loading templates…</span>
            </div>
            } @else {
            <p-select
                [options]="refOptions()"
                optionLabel="label"
                optionValue="value"
                [ngModel]="refSiteTemplateId()"
                (ngModelChange)="refSiteTemplateId.set($event ?? null)"
                placeholder="Select a reference template"
                appendTo="body"
                [style]="{ width: '100%' }"
            />
            }
        </div>
        }

        @if (blockReason()) {
        <p-message severity="warn" [text]="blockReason()!" />
        } @if (genError()) {
        <p-message severity="error" [text]="genError()!" />
        } @if (generating()) {
        <div class="flex items-center gap-2 text-muted-color text-sm py-2">
            <p-progress-spinner
                [style]="{ width: '1.5rem', height: '1.5rem' }"
                strokeWidth="6"
            />
            <span>Generating storyboard — this can take a minute…</span>
        </div>
        }
    </div>

    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button
                label="Cancel"
                severity="secondary"
                outlined
                [disabled]="generating()"
                (onClick)="close()"
            />
            <p-button
                label="Generate"
                icon="pi pi-microchip-ai"
                [loading]="generating()"
                [disabled]="!!blockReason()"
                (onClick)="generate()"
            />
        </div>
    </ng-template>
    }

    <!-- ── Results ────────────────────────────────────────────────────────── -->
    @if (phase() === 'results') {
    <div class="flex flex-col gap-5">
        @for (page of pages(); track page.index) {
        <div class="flex flex-col gap-2">
            <div class="flex items-baseline gap-2">
                <span class="font-medium">Page {{ page.index }}</span>
                <span class="text-xs text-muted-color capitalize">{{
                    page.scene.replaceAll('_', ' ')
                }}</span>
                @if (page.cta) {
                <span class="text-xs text-muted-color">· "{{ page.cta }}"</span>
                }
            </div>
            <div class="flex flex-wrap gap-3">
                @for (cand of page.candidates; track cand.url) {
                <button
                    type="button"
                    class="rounded border-2 overflow-hidden transition-colors relative"
                    [ngClass]="
                        isSelected(page.index, cand.url)
                            ? 'border-primary'
                            : 'border-surface-200 dark:border-surface-700 hover:border-primary/50'
                    "
                    [disabled]="saving()"
                    (click)="pick(page.index, cand)"
                >
                    <img
                        [src]="cand.url"
                        [alt]="'Page ' + page.index"
                        class="block w-32 h-56 object-cover"
                    />
                    <i
                        class="pi pi-search-plus absolute top-1 left-1 bg-black/50 text-white rounded p-1 text-xs"
                        title="View large"
                        (click)="
                            preview.open(cand.url, 'Page ' + page.index);
                            $event.stopPropagation()
                        "
                    ></i>
                    @if (isSelected(page.index, cand.url)) {
                    <span
                        class="absolute top-1 right-1 bg-primary text-primary-contrast rounded-full w-5 h-5 flex items-center justify-center"
                    >
                        <i class="pi pi-check text-xs"></i>
                    </span>
                    }
                </button>
                } @empty {
                <span class="text-sm text-muted-color italic"
                    >No candidates returned.</span
                >
                }
            </div>
        </div>
        }
    </div>

    <ng-template #footer>
        <div class="flex justify-between gap-2">
            <p-button
                label="Back"
                icon="pi pi-arrow-left"
                severity="secondary"
                outlined
                [disabled]="saving()"
                (onClick)="backToConfig()"
            />
            <p-button
                label="Save & apply"
                icon="pi pi-check"
                [loading]="saving()"
                [disabled]="!canSave()"
                (onClick)="save()"
            />
        </div>
    </ng-template>
    }
</p-dialog>
